import React, { ReactNode } from 'react'
import { Modal as BsModal } from 'react-bootstrap';

interface Props {
    show?: Boolean
    style?: React.CSSProperties
};
interface State { };

export default class StatusFrame extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { 
    };
  }

  render() {
    const { children, style, show } = this.props;

    const isHidden = show === false ? { display: 'none' } : {}

    const mappedChildren = React.Children.map(children, (child: ReactNode) => {
      if (child === null) return null;

      return (<div className="render-status-frame-inner" style={{ ...style }}>
          { child }
        </div>);
    })

    return (
      <div className="render-status-frame" style={{...isHidden, ...style}} >
        { mappedChildren }
      </div>
    );
  }
}